/** 
 * @type {import("./defs").StoreProjectFile} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreProjectFile} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreProjectFile.js